import React, { useRef, useMemo, useEffect } from 'react';
import GaugeComponent from 'react-gauge-component';
import html2canvas from 'html2canvas';
import { calcularPorcentajes } from '../../../utilities/calculateFormB';
import styles from '../Styles/DiagnosticBPage.module.css';
function ChartMeasurer({ setValue, realDataTimeForm }) {
  const gaugeEl = useRef(null);

  const stateData = useMemo(() => {
    const { porcentajeTotal } = calcularPorcentajes(realDataTimeForm);
    return { porcentajeTotal: porcentajeTotal || 0 };
  }, [realDataTimeForm]);

  useEffect(() => {
    if (gaugeEl.current) {
      html2canvas(gaugeEl.current).then((canvas) => {
        const base64Image = canvas.toDataURL('image/jpg');
        setValue('chatMeasurerImg', base64Image);
      });
    }
  }, []);

  return (
    <div className={styles.charMeasurer} ref={gaugeEl}>
      <GaugeComponent
        pointer={{ color: 'black' }}
        arc={{
          subArcs: [
            {
              limit: 33,
              color: '#EA4228',
            },

            {
              limit: 63,
              color: '#F5CD19',
            },
            {
              limit: 100,
              color: '#5BE12C',
            },
          ],
        }}
        type="semicircle"
        value={stateData.porcentajeTotal}
      />
    </div>
  );
}

export default ChartMeasurer;
